import React from 'react';
import {IoCloseOutline, IoOpen} from 'react-icons/io5';
import Img from 'gatsby-image';
import {Link, navigate} from 'gatsby';
export default function About(props) {
  return !props.data ? null : (
        <div
          className={` w-full h-full pb-12 bg-about-primary text-white transition-all duration-5000`}
        >
          <div className="flex items-center justify-between py-2 px-4 w-full md:px-8">
            <div className="py-3">
              <div>
                <h4 className=" cursor-pointer font-semibold tracking-tighter text-2xl md:font-bold">
                  <Link to="/">{props.data.title}</Link>
                </h4>
              </div>
            </div>
            <div className="flex flex-grow-0 items-center py-3">
              <div className=" flex-row flex justify-end text-3xl cursor-pointer transition-all text-opacity-75 text-white hover:text-opacity-100">
                <div
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <IoCloseOutline />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 w-11/12 grid grid-cols-1 gap-12 mx-auto md:w-10/12 lg:mx-28 lg:w-auto lg:grid-cols-2 lg:mt-24">
            <Img
              className="max-h-96 w-full object-cover md:w-3/4 md:mx-auto lg:w-full xl:w-3/4"
              fluid={props.data.img.childImageSharp.fluid}
            />
            <div>
              <h2 className="text-5xl tracking-tighter font-bold ">
                {props.data.name}
              </h2>
              <p className="text-xl tracking-tight mt-12 ">
                {props.data.description1}
                <br />
                <br />
                {props.data.description2}
              </p>
              <div className=" inline-block">
                <a
                  href="/pdf/Resume_Aditya_Mudgil_(IIT Dhanbad).pdf"
                  className=" mt-12 px-8 py-6 rounded-full bg-about-secondary uppercase shadow-secondary text-white  relative focus:outline-none flex items-center transition-all duration-500 transform hover:-translate-y-3 hover:bg-white hover:text-about-secondary"
                >
                  <span className=" font-bold text-sm tracking-wider mr-2">
                                Resume
                  </span>
                  <span className=" ">
                    <IoOpen />
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className=" mt-14 w-11/12 mx-auto md:w-10/12 lg:w-auto lg:mt-28 lg:mx-28">
            <h2 className="text-2xl tracking-tighter font-bold ">
                    My Interest
            </h2>
            <p className="text-xl tracking-tight mt-12 ">
              {props.data.myInterest}
            </p>
          </div>
          <div className="mt-14 w-11/12 mx-auto md:w-auto md:mt-28 md:mx-28">
            <div className="grid grid-cols-1 gap-4 md:mt-12 md:grid-cols-3 md:gap-0">
              <div>
                <h4 className="text-2xl tracking-tighter font-bold">
                            Experience
                </h4>
                <div> {props.data.myBackground.experience} Yrs. </div>
              </div>
              <div>
                <h4 className="text-2xl tracking-tighter font-bold">
                            Language
                </h4>
                <div>
                  {props.data.myBackground.language.map((item, idx) => (
                    <div key={idx}>
                      {item}
                      <br />
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <h4 className="text-2xl tracking-tighter font-bold">
                            Nationality
                </h4>
                <div>{props.data.myBackground.nationality}</div>
              </div>
            </div>
          </div>
          <div className="mt-12 md:mt-40">
            <ul className="flex flex-row flex-wrap justify-center uppercase md:flex-nowrap">
              {props.data.profiles.map((item, idx) => {
                if (idx < props.data.profiles.length - 1) {
                  return (
                    <li
                      key={idx}
                      className="block border-r border-solid border-opacity-20 border-white"
                    >
                      <a
                        href={item.link}
                        className=" text-sm transition-all duration-300 block no-underline mx-3.5 border-b border-solid border-transparent hover:border-white"
                      >
                        {item.name}
                      </a>
                    </li>
                  );
                } else {
                  return (
                    <li key={idx} className="block">
                      <a
                        href={item.link}
                        className=" text-sm transition-all duration-300 block no-underline mx-3.5 border-b border-solid border-transparent hover:border-white"
                      >
                        {item.name}
                      </a>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        </div>
    );
}
